export default __webpack_public_path__ + "static/media/threPieceChair.ed918ca0.png";